module.exports = __webpack_public_path__ + "static/media/apr 2021.00b17236.svg";